import { CrmTaskStatus } from '@plato/data/prisma';
import { z } from 'zod';
import { richTextSchema } from '../types/common-types.ts';
import { crmAttachmentInputSchema } from './crm-attachment-dto.ts';

export const crmTaskIntent = z.enum([
    'GENERIC',
    'CALL',
    'CLARIFY_PRICE',
    'QUOTE_FOLLOW_UP',
    'QUOTE_CLARIFY_DELIVERY',
    'QUOTE_CONFIRM',
    'QUOTE_MARK_LOST',
]);
export type CrmTaskIntent = z.infer<typeof crmTaskIntent>;

export const crmTaskInputDtoSchema = z.object({
    description: richTextSchema,
    assignedToId: z.uuid().min(1),
    dueDate: z.date(),
    status: z.enum(CrmTaskStatus),
    taskIntent: crmTaskIntent.optional(),
    links: z.array(
        z.object({
            modelType: z.string().min(1),
            modelId: z.string().min(1),
            title: z.string().nullable(),
        }),
    ),
    attachments: z.array(crmAttachmentInputSchema).optional(),
});

export type CrmTaskInputDTO = z.infer<typeof crmTaskInputDtoSchema>;

export const crmTaskBatchInputDtoSchema = z
    .object({
        shared: crmTaskInputDtoSchema.partial(),
        batch: z.array(crmTaskInputDtoSchema.partial()).min(1),
    })
    .transform(({ shared, batch }) => batch.map((task) => ({ ...shared, ...task })))
    .pipe(z.array(crmTaskInputDtoSchema));
